import dashboard from './dashboard';
import membership from './membership'

const menuItems = {
    items: [dashboard, membership]
};

export default menuItems;
